
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rentals",
      function () {
        return require("private-next-pages/rentals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rentals"])
      });
    }
  